import type { ReactNode } from 'react'

/**
 * The shared background treatment (design-spec.md §4): the base colour, two
 * blurred radial glows, and grain. It sits behind 50 of the 52 frames, so it
 * is defined once here and never re-created per screen.
 *
 * The glow geometry is fitted to renders/03-login.png — see tokens.css.
 */
interface ScreenBackgroundProps {
  /** `auth` is the navy hero field; `app` is the #111111 base. */
  variant?: 'auth' | 'app'
  children?: ReactNode
  className?: string
}

export function ScreenBackground({
  variant = 'app',
  children,
  className = '',
}: ScreenBackgroundProps) {
  return (
    <div
      className={`sx-page relative min-h-dvh overflow-hidden ${
        variant === 'auth' ? 'sx-backdrop' : 'sx-backdrop-app'
      } ${className}`}
    >
      <div className="sx-grain-layer absolute inset-0" aria-hidden="true" />
      {children}
    </div>
  )
}
